// Decode a JWT payload without verifying it (verification is the backend's job).
// Used only to know when the stored access token has expired so the shell
// can drop a stale session instead of showing the launcher to a logged-out user.
export const decodeJwt = (token) => {
  try {
    const payload = token.split(".")[1];
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
};

// Treats an unreadable token as expired. Tokens without `exp` never expire client-side.
export const isTokenExpired = (token, skewSeconds = 10) => {
  if (!token) return true;
  const payload = decodeJwt(token);
  if (!payload) return true;
  if (!payload.exp) return false;
  return payload.exp * 1000 <= Date.now() + skewSeconds * 1000;
};
